// export default {
//   home: "Home",
//   restaurants: "Restaurants",
//   suppliers: "Suppliers",
//   about.menu: "About",
//   blog: "Blog",
//   contact: "Contact",
//   login: "Login",

//   login_as: "Login As",
//   restaurant: "Restaurant",
//   supplier: "Supplier",
//   admin: "Admin",
//   orders_menu: "Orders & Menu",
//   supply_mgmt: "Supply Management",
//   system_control: "System Control",
// }
export default {
  home: "Home",
  restaurants: "Restaurants",
  suppliers: "Suppliers",
  "about.menu": "About",
  blog: "Blog",
  contact: "Contact",
  login: "Login",

  login_as: "Login As",
  restaurant: "Restaurant",
  supplier: "Supplier",
  admin: "Admin",

  orders_menu: "Orders & Menu",
  supply_mgmt: "Supply Management",
  system_control: "System Control",
};